export default class SelectControl {
  #ctrl: any;
  #value: any[] = [];
  #isMultiselect;

  constructor(
    controlWrapper: any,
    parameterMeta: any,
    finishedInteractionCallback: Function
  ) {
    this.#isMultiselect = parameterMeta.control.controltype === "multiselect";
    this.#init(controlWrapper, parameterMeta, finishedInteractionCallback);
  }

  #init(
    controlWrapper: any,
    parameterMeta: any,
    finishedInteractionCallback: any
  ) {
    const that = this;
    const labelHTML = "<label>" + parameterMeta.label + ":</label>";
    $(controlWrapper).append(labelHTML);
    const sel = $(
      `<select multiple class="control multiselect ${parameterMeta.name}"></>`
    );
    parameterMeta.control.options.forEach((o: any) => {
      sel.append($("<option />", { value: o.value, text: o.label }));
    });
    parameterMeta.defaultvalue.forEach((v: any) => {
      sel.children(`option[value=${v}]`).prop("selected", true);
    });
    $(controlWrapper).append(sel);

    const f = function (e: any) {
      const currentlyselected = $(e.currentTarget).prop("selected");

      //Prevent jumpy scroll when selecting/deselecting
      var scrolltop: number = $(e.currentTarget).parent().scrollTop()!;
      e.target.selected = !e.target.selected;
      setTimeout(function () {
        $(e.currentTarget).parent().scrollTop(scrolltop);
      }, 0);

      if (!that.#isMultiselect)
        $(e.currentTarget)
          .parent()
          .children("option:selected")
          .prop("selected", false);
      if (!currentlyselected) {
        //select
        $(e.currentTarget).prop("selected", true);
      } else {
        //deselect
        $(e.currentTarget).prop("selected", false);
      }
      that.#value = [];

      $(e.currentTarget)
        .parent()
        .children("option:selected")
        .each((_, el) => {
          that.#value.push($(el).attr("value"));
        });
      e.preventDefault();
      finishedInteractionCallback();
    };

    sel.children("option").on("mousedown", f).on("touchstart", f);
    that.#value = parameterMeta.defaultvalue;
    sel.data("public", that);
  }

  getValue() {
    return this.#value;
  }
}
